export default [
  {
    path: '/leads',
    name: 'leads',
    component: () => import('@/router/views/Leads'),
    meta: {
      auth: true
    }
  },
  {
    path: '/upgrade',
    name: 'upgrade',
    component: () => import('@/router/views/Upgrade'),
    meta: {
      auth: true
    }
  },
  {
    path: '/upgrade-enterprise',
    name: 'upgradeEnterprise',
    component: () => import('@/router/views/UpgradeEnterprise'),
    meta: {
      auth: true
    }
  },
  {
    path: '/',
    name: 'login',
    component: () => import('@/router/views/Login'),
    meta: {
      auth: false
    }
  },
  {
    path: '/register',
    name: 'signUp',
    component: () => import('@/router/views/SignUp'),
    meta: {
      auth: false
    }
  },
  {
    path: '/forgot',
    name: 'forgotPassword',
    component: () => import('@/router/views/ForgotPassword'),
    meta: {
      auth: false
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/router/views/Dashboard'),
    meta: {
      auth: true
    }
  },
  {
    path: '/content',
    name: 'content',
    component: () => import('@/router/views/Content'),
    meta: {
      auth: true
    }
  },
  {
    path: '/content/:folder',
    name: 'folder',
    component: () => import('@/router/views/Content'),
    meta: {
      auth: true
    }
  },
  // {
  //   path: '/content/:id/:tab',
  //   name: 'document',
  //   component: () => import('@/router/views/Document'),
  //   meta: {
  //     auth: true
  //   }
  // },
  {
    path: '/documents/:id/:tab?',
    name: 'documentDetail',
    component: () => import('@/router/views/DocumentDetail'),
    meta: {
      auth: true
    }
  },
  {
    path: '/profile/:tab',
    name: 'profileTab',
    component: () => import('@/router/views/Profile'),
    meta: {
      auth: true,
      delinquent: true
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/router/views/Profile'),
    meta: {
      auth: true
    }
  },
  // {
  //   path: '/visualizer/:id',
  //   name: 'visualizer',
  //   component: () => import('@/router/views/Visualizer')
  // },
  {
    path: '/confirm/:id',
    name: 'confirm',
    component: () => import('@/router/views/Confirm')
  },
  {
    path: '/reconfirm/',
    name: 'reconfirm',
    component: () => import('@/router/views/RequestConfirmationEmail')
  },
  {
    path: '/recover/:id',
    name: 'recover',
    component: () => import('@/router/views/RecoverPassword'),
    meta: {
      auth: false
    }
  },
  {
    path: '/upload/:id?',
    name: 'upload',
    component: () => import('@/router/views/Upload'),
    meta: {
      auth: true
    }
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import('@/router/views/Reports'),
    meta: {
      auth: true
    }
  },
  {
    path: '/library',
    name: 'library',
    component: () => import('@/router/views/Library'),
    meta: {
      auth: true
    }
  },
  {
    path: '/integrations',
    name: 'integrations',
    component: () => import('@/router/views/Integrations'),
    meta: {
      auth: true
    }
  },
  {
    path: '/teams/accept/:code',
    name: 'acceptInvite',
    component: () => import('@/router/views/AcceptInvite')
  },
  {
    path: '/subscription/confirmation',
    name: 'subscriptionConfirmation',
    component: () => import('@/router/views/SubscriptionConfirmation')
  },
  {
    path: '/subscription/confirmation',
    name: 'subscriptionConfirmation',
    component: () => import('@/router/views/SubscriptionConfirmation')
  },
  {
    path: '/billing-close',
    name: 'billingClose',
    component: () => import('@/router/views/BillingPortalClose'),
    meta: {
      auth: true
    }
  },
  {
    path: '*',
    redirect: '/'
  }
];
